import {captureException} from "@sentry/react";
import {applyMiddleware, combineReducers, createStore} from "redux";
import {default as createSagaMiddleware} from "redux-saga";
import * as reducers from "modules/reducers";
import {rootSaga} from "modules/sagas";

const sagaMiddleware = createSagaMiddleware({
	onError(error: Error) {
		captureException(error);
		console.error(error);
	},
});

export const rootReducer = combineReducers(reducers);

export const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootSaga);
